module.exports = __webpack_public_path__ + "static/helpWithAddictions-logo-0cb9958792fcd5d68c579ba45159399b.png";